var map = {
	"./about.js": "f286",
	"./account.js": "035a",
	"./active.js": "428d",
	"./findpwd.js": "1b8d",
	"./findpwd_h5.js": "fdfe",
	"./gamelist_h5.js": "e335",
	"./home.js": "9f25",
	"./login.js": "6b6c",
	"./login_h5.js": "2dcb",
	"./news.js": "fac0",
	"./pay_h5.js": "8726",
	"./paygame.js": "e885",
	"./pays_h5.js": "b199",
	"./service.js": "8c81",
	"./signup.js": "fe40",
	"./signup_h5.js": "f4dc",
	"./siteinfo.js": "6a5d",
	"./terms.js": "9fe2",
	"./tokusyouhou.js": "525a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f5b";